import { requestJson } from './requestJson';
import { buildApiUrl } from './apiUrl';

const USER_REQUESTS_ENDPOINT = buildApiUrl('/api/user-requests');

function authHeaders(accessToken) {
  if (!accessToken) {
    return {};
  }

  return {
    Authorization: `Bearer ${accessToken}`,
  };
}

async function postUserRequest(action, payload, accessToken) {
  return requestJson(USER_REQUESTS_ENDPOINT, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...authHeaders(accessToken),
    },
    body: JSON.stringify({
      action,
      ...payload,
    }),
  });
}

export async function requestNewUser(payload, accessToken) {
  return postUserRequest('requestNewUser', payload, accessToken);
}

export async function requestRoleChange(payload, accessToken) {
  return postUserRequest('requestRoleChange', payload, accessToken);
}

export async function requestDeleteUser(payload, accessToken) {
  return postUserRequest('requestDeleteUser', payload, accessToken);
}

export async function requestMoveUser(payload, accessToken) {
  return postUserRequest('requestMoveUser', payload, accessToken);
}

export async function requestUpdateUserInfo(payload, accessToken) {
  return postUserRequest('requestUpdateUserInfo', payload, accessToken);
}

export async function fetchRequestRoleOptions(accessToken) {
  return postUserRequest('getRoleOptions', {}, accessToken);
}

export async function fetchLocationRequests(accessToken) {
  return postUserRequest('getLocationRequests', {}, accessToken);
}

export async function fetchPendingUserRequests(accessToken) {
  return postUserRequest('getLocationRequests', {}, accessToken);
}

export async function cancelLocationRequest(payload, accessToken) {
  return postUserRequest('cancelLocationRequest', payload, accessToken);
}
